import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-device-card',
  templateUrl: './device-card.component.html',
  styleUrls: ['./device-card.component.scss']
})
export class DeviceCardComponent implements OnInit {

  @Input('product') product: any;
  @Input('index') index: any;
  @Output() onClickAdd = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }
  
  addItem( product: any) {  
    this.onClickAdd.emit(product)
  }
  calculatePercentage(product:any) {
    return Math.floor(100 -((product?.price* 100)/product?.oldPrice ))
  }

  floorNumber(number:any){
    return Math.floor(number)
  }
}
